import { create } from 'zustand';

export const useTimezoneStore = create((set, get) => ({
  timezone: null,
  isInitialized: false,
  initializeTimezone: (initial) => set({ timezone: initial, isInitialized: true }),
  setTimezone: (newTimezone) => set({ timezone: newTimezone }),
  isValidDate: (date) => {
    return date instanceof Date && !isNaN(date);
  },
  getCurrentUserMidnight: () => {
    const { timezone, isInitialized, isValidDate } = get();

    if (!isInitialized || !timezone) {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }

    const now = new Date();
    const userDateStr = now.toLocaleString('en-US', { timeZone: timezone });
    const userDate = new Date(userDateStr);

    if (isValidDate(userDate)) {
      return new Date(userDate.getFullYear(), userDate.getMonth(), userDate.getDate());
    }

    const utcNow = new Date();
    return new Date(Date.UTC(utcNow.getUTCFullYear(), utcNow.getUTCMonth(), utcNow.getUTCDate()));
  },
  formatDate: (date) => {
    const { timezone, isInitialized, isValidDate } = get();

    if (!isValidDate(date) || !isInitialized) {
      const fallbackDate = new Date();
      fallbackDate.setHours(0, 0, 0, 0);
      date = fallbackDate;
    }

    try {
      const formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });

      const formatted = formatter.format(date);
      return `${formatted} 00:00:00`;
    } catch (error) {
      console.error('Error formatting date with user timezone:', error);
      return date.toISOString().split('T')[0] + ' 00:00:00';
    }
  },
  toUserTzDate: (dateInput) => {
    const { timezone, isInitialized, isValidDate } = get();

    try {
      let date = dateInput instanceof Date ? dateInput : new Date(dateInput);

      if (!isValidDate(date) || isInitialized) {
        throw new Error('Invalid date input');
      }

      const userDateStr = date.toLocaleString('en-US', { timeZone: timezone });
      const userDate = new Date(userDateStr);

      if (isValidDate(userDate)) {
        return new Date(userDate.getFullYear(), userDate.getMonth(), userDate.getDate());
      }

      throw new Error('Failed to convert to user timezone');
    } catch (error) {
      console.error('Error converting to user timezone:', error);
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
  },
}));
